/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Workout_Session_LabelInputs */

const en_us2_workout_session_label = /** @type {(inputs: Workout_Session_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workout ${i?.label}`)
};

const pt_br2_workout_session_label = /** @type {(inputs: Workout_Session_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.label}`)
};

const es_419_workout_session_label = /** @type {(inputs: Workout_Session_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrenamiento ${i?.label}`)
};

const pt_pt2_workout_session_label = /** @type {(inputs: Workout_Session_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.label}`)
};

const fr_fr2_workout_session_label = /** @type {(inputs: Workout_Session_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séance ${i?.label}`)
};

const de_de2_workout_session_label = /** @type {(inputs: Workout_Session_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Training ${i?.label}`)
};

const it_it2_workout_session_label = /** @type {(inputs: Workout_Session_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Allenamento ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Workout {label}" |
*
* @param {Workout_Session_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_session_label = /** @type {((inputs: Workout_Session_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Session_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_session_label(inputs)
	if (locale === "es-419") return es_419_workout_session_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_session_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_session_label(inputs)
	if (locale === "de-DE") return de_de2_workout_session_label(inputs)
	if (locale === "it-IT") return it_it2_workout_session_label(inputs)
	return en_us2_workout_session_label(inputs)
});
export { workout_session_label as "workout.session_label" }